'use client'

import { usePathname } from 'next/navigation'
import { createContext, useCallback, useContext, useState } from 'react'

import { useRenewStore } from '@/features/studio-renew/store'

import type { ReactNode } from 'react'

const ValidationContext = createContext({ attempted: false, reveal: () => {} })

export const useStudioValidation = () => useContext(ValidationContext)

export function ValidationSession({ children }: { children: ReactNode }) {
  const [attempted, setAttempted] = useState(false)
  const reveal = useCallback(() => setAttempted(true), [])
  return (
    <ValidationContext.Provider value={{ attempted, reveal }}>
      {children}
    </ValidationContext.Provider>
  )
}

/** 같은 재료의 단계 이동에는 검사 표시를 유지하고, 목록·다른 재료·다른 계정에서는 초기화한다. */
export function StudioValidationBoundary({
  children,
}: {
  children: ReactNode
}) {
  const pathname = usePathname()
  const owner = useRenewStore((state) => state.owner)
  const editor = /^\/studio-renew\/([^/]+)\/([^/]+)\//.exec(pathname)
  const scope = editor ? `${editor[1]}/${editor[2]}` : pathname
  return (
    <ValidationSession key={`${owner}:${scope}`}>{children}</ValidationSession>
  )
}
